import React, {FC} from 'react';
import styled, {useTheme} from 'styled-components';

import {ticketStatusCategoryColors} from '../../../../libs/inboxes/ui/src/ticketing/ticketStatus';
import {TicketStatusName} from '../../../../libs/inboxes/ui/src/ticketing/ticketStatusName';
import {TicketStatusModel} from '../../../../libs/shared/core/src/models/api/ticketStatusModel';
import {Pill} from '../../../../libs/shared/ui/src/components/pill/pill';
import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface TicketStatusPillProps {
  ticketStatus: TicketStatusModel;
  isCompact?: boolean;
}

/*
 * Style.
 */

const StyledPill = styled(Pill)`
  display: flex;
  align-items: center;
  line-height: ${fontSizes.tiny};
  overflow: hidden;
  margin-left: 4px;
  padding: 2.5px 5px;
`;

/*
 * Component.
 */

export const TicketStatusPill: FC<TicketStatusPillProps> = ({isCompact, ticketStatus: {category, tagId}}) => {
  const theme = useTheme();
  const color = theme.palette[ticketStatusCategoryColors[category]];

  return isCompact ? (
    <StyledPill backgroundColor={color.shade20} color={color.shade50} size={VisualSizesEnum.MEDIUM}>
      <TooltipCoordinator render={() => <TicketStatusName tagId={tagId} />}>
        <TooltipOverflowCondition>
          <TicketStatusName tagId={tagId} />
        </TooltipOverflowCondition>
      </TooltipCoordinator>
    </StyledPill>
  ) : (
    <StyledPill backgroundColor={color.shade20} color={color.shade50} size={VisualSizesEnum.MEDIUM}>
      <TicketStatusName tagId={tagId} />
    </StyledPill>
  );
};
